import { Auth0OrganizationID, Auth0OrganizationName } from '../models';

export function getRedirectSubdomain(subDomain: string) {
  switch (subDomain) {
    case 'p2p':
      return 'p2p';

    case 'dev':
    case 'dev2':
      return 'dev';

    case 'staging':
    case 'staging2':
      return 'staging';

    default:
      return undefined;
  }
}

export function getRedirectUrl(url: string) {
  const obj = new URL(url);
  const parts = obj.hostname.split('.');

  if (parts.length > 2) {
    const domain = parts.slice(-2).join('.');

    const subDomain = parts?.[0];
    const redirectSubdomain = getRedirectSubdomain(subDomain);

    obj.hostname = !!redirectSubdomain ? `${redirectSubdomain}.${domain}` : domain;
  }

  return obj.href;
}

export interface GetRedirectUrlByOrgRequest {
  baseUrl: string;
  orgName: Auth0OrganizationName | undefined;
  orgId: Auth0OrganizationID | undefined;
}

export function getRedirectUrlByOrg({ baseUrl, orgId, orgName }: GetRedirectUrlByOrgRequest) {
  return `${getRedirectUrl(baseUrl)}${getRedirectUrlParams({ orgId, orgName })}`;
}

interface GetRedirectUrlParamsRequest {
  orgId?: Auth0OrganizationID;
  orgName?: Auth0OrganizationName;
}

function getRedirectUrlParams({ orgId, orgName }: GetRedirectUrlParamsRequest) {
  if (!orgName && !orgId) {
    return '';
  }

  const params: string[] = [];

  if (orgName) {
    params.push(`org=${orgName}`);
  }

  if (orgId) {
    params.push(`organization=${orgId}`);
  }

  return `?${params.join('&')}`;
}

export function addParam(url: string, param: string) {
  return url?.includes('?')
    ? `${url}&${param}`
    : `${url}?${param}`;
}
